import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";
import { useLang } from "@/i18n/LangContext";

export const Method = () => {
  const { t } = useLang();
  const m = t.home.method;
  return (
  <section className="px-5 md:px-10 py-24 md:py-32" data-testid="method">
    <div className="mx-auto max-w-7xl">
      <div className="max-w-3xl">
        <SectionTag>{m.tag}</SectionTag>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-balance">
            {m.h2}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-plum/80">
            {m.subtitle}
          </p>
        </Reveal>
      </div>

      <ol className="relative mt-16 md:mt-24 grid gap-10 md:grid-cols-2 lg:grid-cols-3 md:gap-x-12 md:gap-y-16">
        {m.steps.map((step, i) => (
          <Reveal key={step.title} delay={i * 0.08} className="h-full">
            <li className="group relative h-full rounded-3xl border border-ink/5 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-15px_rgba(17,14,13,0.12)]">
              <span className="font-display text-5xl font-extrabold tracking-tighter text-terracotta/35 transition-colors duration-500 group-hover:text-terracotta">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-5 font-display text-xl font-bold tracking-tight">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-plum/75">{step.text}</p>
              {i < m.steps.length - 1 && (
                <span className="absolute top-1/2 -right-6 hidden h-px w-6 bg-terracotta/40 lg:block" aria-hidden="true" />
              )}
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
  );
};
